var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('img',{staticClass:"logo",attrs:{"alt":"logo","src":require("@/assets/imgs/logo.svg")}})]),_c('v-row',{attrs:{"justify":"center"}},[_c('login-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }